import { render, staticRenderFns } from "./AdicionarMetasLote.vue?vue&type=template&id=160f88d8"
import script from "./AdicionarMetasLote.vue?vue&type=script&lang=ts"
export * from "./AdicionarMetasLote.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports